/**
 * Human labels for Intent v1 slot ids.
 *
 * The server sends coverage as bare slot ids (`reproSteps`, `expectedVsActual`).
 * The shared slot registry is the one place those ids carry a reporter-facing
 * label and the non-engineer question that fills them, so the web app reads
 * from it rather than keeping a second copy that can drift.
 */

import { SLOT_REGISTRY, type SlotId } from "@spectree/shared";

/** True when `id` is a slot id the shared registry knows about. */
export function isKnownSlotId(id: string): id is SlotId {
  return Object.prototype.hasOwnProperty.call(SLOT_REGISTRY, id);
}

/**
 * Reporter-facing label for a slot id.
 *
 * Falls back to the raw id so a slot added server-side before the web bundle
 * is rebuilt still renders something meaningful instead of `undefined`.
 */
export function slotLabel(id: string): string {
  return isKnownSlotId(id) ? SLOT_REGISTRY[id].label : id;
}

/**
 * The non-engineer question a human must answer to fill a slot, or `undefined`
 * for an unrecognised id.
 */
export function slotQuestion(id: string): string | undefined {
  return isKnownSlotId(id) ? SLOT_REGISTRY[id].question : undefined;
}
